import {AvatarStack} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import type {Thread, Author} from '@github-ui/diff-lines/conversation-types'
import {useMemo} from 'react'

type Props = {
  skipCommentById?: string
  thread: Thread
}

export function PreviewAuthors({skipCommentById, thread}: Props) {
  const commentAuthors = useMemo(() => {
    const uniqueAuthors = new Set<string>()
    const commentsArray = thread?.commentsData?.comments ?? []

    const extractedAuthors = commentsArray.reduce<Author[]>((authors, comment) => {
      if (comment?.id === skipCommentById) return authors

      const author = comment.author
      if (!author || !author.avatarUrl) return authors

      if (!uniqueAuthors.has(author.avatarUrl)) {
        authors.push(author)
        uniqueAuthors.add(author.avatarUrl)
      }

      return authors
    }, [])

    return extractedAuthors
  }, [skipCommentById, thread?.commentsData?.comments])

  if (commentAuthors.length < 1) return null

  return (
    <AvatarStack>
      {commentAuthors.map(({login, avatarUrl}) => (
        <GitHubAvatar key={avatarUrl} alt={login} size={18} src={avatarUrl} />
      ))}
    </AvatarStack>
  )
}
